import { useCallback } from 'react';

import ROUTES from '@/common/routes';
import { useHistory } from '@/modules/core/hooks';
import { EMAIL_QUERY_KEY, USERNAME_QUERY_KEY } from '@/modules/user/components/SignUp/signUp.constants';

interface Props {
  username: string;
  email: string;
}

const useHandleUnconfirmedUserEmailError = () => {
  const { push } = useHistory();

  const handleUnconfirmedUserEmailError = useCallback(({ username, email }: Props) => {
    push(`${ROUTES.VERIFY_EMAIL}?${USERNAME_QUERY_KEY}=${username}&${EMAIL_QUERY_KEY}=${email}`);
  }, [push]);

  return {
    handleUnconfirmedUserEmailError,
  };
};

export default useHandleUnconfirmedUserEmailError;
